<template>
<div id="facturas_transito_transportista">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container grid-list-md text-xs-center>

        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Reporte Facturas Comercio Exterior" class="elevation-1 px-5 py-3">
                <br />
                
                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="formreportecomercio" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu5" v-model="menu5" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu5 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu5 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu6" v-model="menu6" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu6 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu6 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-switch
                                            v-model="fecha_factura"
                                            color="red darken-3"
                                            label="Fecha de Emisión"
                                        ></v-switch>
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="8" lg="8" v-if="es_grupo==0">
                                            <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_seleccionado" 
                                                :item-text="getNombreGrupo" item-value="rfc" clearable label="Seleccione Emisor" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="8" lg="8" v-else >
                                            <v-autocomplete :hide-no-data="true" :items="clientesTransportista" v-model="rfc_cliente_seleccionado" 
                                                :item-text="getNombreCliente" item-value="rfc" clearable label="Seleccione Cliente" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">                                             
                                            &nbsp;
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            &nbsp;
                                        </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="8" lg="8">
                                            <v-autocomplete :hide-no-data="true" :items="tiposComprobante" v-model="model.tipo_comprobante" clearable
                                                item-text="nombre" item-value="nombre" label="Seleccione Tipo de Comprobante" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn rounded color="primary" @click="generar_reporte_sqs_comercio()" :loading="loadingReporte">
                                                <v-icon>done</v-icon>Generar Reporte
                                            </v-btn>
                                          </v-col>
                                          <v-col sm="12" md="2" lg="2">
                                             &nbsp;
                                          </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>

                            <v-card>
                                <v-card-text>

                                    <v-refresh-button :funcion="cargarReportesComercio" />
                                    <v-client-table ref="vuetable" :data="datos_comercio" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn>
                                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    
            </base-material-card>
        </v-flex>

    </v-container>
    
    
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    computed: {
        datafiltered() {
            if (this.$refs['vuetabledetalle'] != null)
                return this.$refs.vuetabledetalle.allFilteredData;
            else
                return [];
        },
    },
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.URL = this.$hostname + "reportes/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");

        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.model.rfc = this.$local_storage.get("rfc_grupo");
            this.es_grupo = 1;
            this.getClientesTransportista();
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
            this.getTransportistas();
        }
        
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario" || tipoUsuario == "Grupo")
            this.permisoEliminar = true;
        
        this.cargarReportesComercio();            
        
        var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);



                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();


                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;


                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
    },
    filters: {
        uppercase: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },
    },
    data: () => ({
        es_grupo:0,
        clientesTransportista:[],
        rfc_cliente_seleccionado:"",
        gruposTransportistas:[],
        rfc_grupo_seleccionado:"",
        permisoEliminar: false,
        tab: null,
        qrSrc: null,
        data_table_impo: [],
        lista_filtrada: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext",
            },
           
            {
                text: "Facturas en Tránsito",
                disabled: true,
                to: "",
            },
        ],

        update: false,

        file: "",
        cliente: "",
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',
        loadingBtn:false,
        modalProforma: false,
        model_proforma: {
            transportista:'',
            hbl:'',
            contenedor:'',
            facturas:'',
            agente_carga:'',
        },

        to_download: [],
        dialog1: false,
        dialog2: false,
        listado: "",
        datos: [],
        datos_comercio: [],
        allChecked: false,
        columns: [
            "id",
            "fecha_solicitud",
            "usuario_email",
            "nombre_reporte",
            "criterio",
            "fecha_generacion",
            "estatus",
            "error",
            "actions",
        ],
        options: {
            filterable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],
            sortable: [
                "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar",
            },
        },
        loading: true,
        loadingReporte: false,
        show_loading: true,
        tiposComprobante:[{"nombre":"Ingreso"},
            {"nombre":"Traslado"}
        ],
        model: {
            rfc: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            tipo_comprobante:"",
            reporte_url: "/reportes_ws/consulta_adjuntos/",
            nombre_reporte: "Facturas en Tránsito",
            tipo: "Facturas Transito",
            tipo_reporte: "",
            archivo: "", //para buscar por nombre de adjunto
            integrado: 0
        },
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,
        fecha_factura: false,
        tiposDocumentos: [],
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

        modal: false,
        data_resumen: [],
        data_resumen_excel: {
            RFC: "rfc",
            Fecha: "fecha",
            Usuario: "nombre_usuario",
            Archivo: "filename",
            "RFC factura": "rfc_factura",
            "Razon Social": "razon_social",
            Folio: "folio",
            "Fecha Emisión": "fecha_emision",
            "Tipo CFDI":"tipo_cfdi",
            "Importe":"importe",            

        },
        columns_resumen: [
            "rfc_grupo",
            "rfc",            
            "fecha",
            "iniciales",
            "filename",
            "rfc_factura",
            "folio",
            "fecha_emision",
            "tipo_cfdi",
            "importe",            
            "actions_view"
        ],
        options_resumen: {
            filterable: [
                "rfc_grupo",
                "rfc",
                "fecha",
                "iniciales",
                "filename",
                "rfc_factura",
                "folio",
                "fecha_emision",
                 "tipo_cfdi",
                "importe",                
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            sortable: [
                "rfc_grupo",
                "rfc",
                "fecha",
                "iniciales",
                "filename",
                "rfc_factura",
                "folio",
                "fecha_emision",
                "tipo_cfdi",
                "importe",                
            ],
            headings: {
                "rfc_grupo":"RFC Transportista",
                "rfc":"RFC",
                fecha: "Fecha",
                iniciales: "Usuario",
                filename: "Archivo",
                rfc_factura: "RFC Factura",
                descripcion: "Tipo de Documento",
                folio: "Folio",
                fecha_emision: "Fecha Emision",
                "tipo_cfdi":"Tipo CFDI",
                "importe":"Importe",
                actions_view: 'Opciones'
            },
        },
    }),
    methods: {
        getNombreGrupo:function(row){
            return row.rfc+" - "+row.grupo;
        },
        getTransportistas: function(){            
            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),                
            };
            axios.post(this.$hostname+ "grupos/get_grupos_rfc/", data)            
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.gruposTransportistas = res.data;
                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        getNombreCliente:function(row){
            if(row.metadato!=null && row.metadato!="")
                return row.rfc+" - "+row.metadato;
            else
                return row.rfc+" - "+row.razon_social;
        },
        getClientesTransportista: function(){
            let data = {
                id_grupo: this.$local_storage.get("id_grupo"),                
            };
            axios.post(this.$hostname+ "grupos/get_rfcs/", data)            
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientesTransportista = res.data;                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        
        cargarReportesComercio: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas_Comercio_Exterior_Transportista"
            };
            if (this.$local_storage.get("es_transportista") == 0) {
                data["tipo"] = "Facturas_Comercio_Exterior_Transportista_Cliente"
            }
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos_comercio = res.data;
                        this.datos_comercio.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos_comercio) {
                            this.datos_comercio[k].fecha_solicitud = this.parseDate(this.datos_comercio[k].fecha_solicitud);
                            this.datos_comercio[k].fecha_generacion = this.parseDate(this.datos_comercio[k].fecha_generacion);
                            this.datos_comercio[k].estatus = this.getEstatus(this.datos_comercio[k].estatus);
                            this.datos_comercio[k].criterio = this.getCriterioPredeterminadosDS(this.datos_comercio[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getCriterioPredeterminadosDS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if (params.tipo_reporte== undefined && params.fecha_de!=undefined ){
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 1) {
                        return "Pedimento: " + params.pedimento;
                    } else if (params.tipo_reporte == 3) {
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 4) {
                        return "Búsqueda por listado de pedimentos";
                    }
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }

        },
        
                
        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },
        
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },

        
        getCriterioPredeterminados: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);

                    let c = "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

                    if (params.lista != undefined && params.lista.length > 0) {
                        c = " Orden: ";

                        params.lista.forEach(function (item) {
                            c += item + " | ";
                            console.log(item);
                        });
                    }

                    return c;

                } else {
                    return "N/A";
                }
            } catch (error) {
                return "N/A-error";
            }

        },
        getEstatus: function (estatus) {
            var arr_estatus = [
                "Pendiente",
                "Encolado",
                "Generado Correctamente",
                "Con Errores",
            ];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return "N/A";
        },
        
        generar_reporte_sqs_comercio() {
           if (!this.$refs.formreportecomercio.validate()) {
               //Alguna operación o mensaje
           } else {

               this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
               var data = {
                    rfc: this.model.rfc,
                    usuario: this.model.usuario,
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    reporte_url: "/reportes_ws/facturas_comercio_exterior_transportista/",
                    nombre_reporte: "Facturas De Comercio Exterior",
                    tipo: "Facturas_Comercio_Exterior_Transportista",
                    fecha_factura: this.fecha_factura,
                    tipo_comprobante: this.model.tipo_comprobante==null?"":this.model.tipo_comprobante,
                    es_grupo: this.es_grupo
                };

                if(this.rfc_grupo_seleccionado!=null && this.rfc_grupo_seleccionado!="")
                    data["rfc_emisor"] = this.rfc_grupo_seleccionado;
                else 
                    data["rfc_emisor"] = "";

                if(this.rfc_cliente_seleccionado!=null && this.rfc_cliente_seleccionado!="")
                    data["rfc_cliente"] = this.rfc_cliente_seleccionado;
                else 
                    data["rfc_cliente"] = "";      
                    
                if (this.$local_storage.get("es_transportista") == 0) {
                    data["tipo"] = "Facturas_Comercio_Exterior_Transportista_Cliente"
                }
                    
               axios({
                       method: "post",
                       url: this.$hostname + "reportes/save_reporte/",                       
                       data: data
                   })
                   .then(response => {

                       this.$swal({
                           type: "success",
                           title: "Operación Exitosa",
                           text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                           footer: ""
                       });
                   })
                   .catch(error => {
                       let mensaje;
                       var titulo = "¡Operación no Permitida!";
                       var tipo = "error";
                       if (typeof error.response !== "undefined") {
                           mensaje = error.response.data.mensaje;
                           if (error.response.status == 406) {
                               titulo = "¡Ya existe un reporte en proceso!";
                               tipo = "info";
                           }
                       } else {
                           mensaje = "Ocurrió un error al generar el reporte";
                       }
                       this.$swal({
                           type: tipo,
                           title: titulo,
                           text: mensaje,
                           footer: ""
                       });
                   }).then(() => {
                       this.$root.$dialogLoader.hide();
                       this.cargarReportesComercio();
                   });
           }
       },
      
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        
        downloadReporte: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el reporte con No. Proceso: " +
                    idreporte +
                    "?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id_reporte: idreporte,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_reporte/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El reporte se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();                            
                            this.cargarReportesComercio();
                        });
                }
            });
        },
                
    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

#pdf {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
}
#facturaProforma {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    /* font-weight: bold;    */
    line-height : 12px;
}
#tablaGenerales >>> th, td {
    border: 0 solid white !important;
    vertical-align: top !important;
    text-align: left !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> th{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> td{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> td {
    font-size: 8px;
    text-align: center !important;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> th {
    font-size: 8px;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:3px !important;
    padding-bottom:3px !important;
}
</style>
